<template>
  <div class="box box-primary">
    <div class="box-header with-border">
      <h3 class="box-title"><i class="fa fa-exchange mr-5"></i>{{'mp_directverkauf' | translate}}</h3>
      <div class="box-tools pull-right"><button type="button" data-widget="collapse" class="btn btn-box-tool"><i class="fa fa-minus"></i></button></div>
    </div>
    <div class="box-body">
      <div class="row">
        <div class="col-md-4 col-sm-6 col-xs-12">
          <h5>{{'wws_config' | translate}}:</h5>
          <p><small class="text-muted">Status: </small><span :class="[erp.is_active === 1 ? 'text-success' : 'text-danger']">{{erp.is_active ? 'aktiv' : 'inaktiv'}}</span><br>
            <small class="text-muted">Deltaexport: </small><span :class="[erp.is_delta_active === 1 ? 'text-success' : 'text-danger']">{{ erp.is_delta_active ? 'aktiv' : 'inaktiv'}}</span><br>
          </p>
          <hr>
          <h5>{{'ftp_config' | translate}}:</h5>
          <p><small class="text-muted">{{'ftp_user' | translate}}: </small>{{ftp.username}}
          </p><br>
        </div>
        <div class="col-md-7 col-sm-6 col-xs-12 border-left">
          <b-table responsive :items="stores" :fields="fields">
            <div slot="cell(marketplace)" slot-scope="data">
              <h5><i :class="`fa  mr-5`"></i>{{ data.item.marketplace }}:</h5>
            </div>
            <div slot="cell(is_active)" slot-scope="data">
              <div data-toggle="btn-toggle" class="btn-group btn-group-sm">
                <button type="button" disabled @click="data.item.is_active = 'active'" :class="{'btn btn-success': true, 'active': data.item.is_active}"><i class="fa fa-check mr-5"></i>{{'active' | translate}}</button>
                <button type="button" disabled @click="data.item.is_active = 'inactive'" :class="{'btn btn-danger': true, 'active': !data.item.is_active}"><i class="fa fa-ban mr-5"></i>{{'inactive' | translate}}</button>
              </div>
            </div>
          </b-table>
        </div>
      </div>
      <div class="box-footer">
        <router-link :to="`/accounting/companies/${this.$route.params.id}/amazonconfiguration`" class="btn btn-info"><i class="fa fa-edit mr-5"></i>{{'edit' | translate}}</router-link>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ['company'],
  name: 'MarketplaceDirectSaleBox',
  data () {
    return {
      title: 'Marktplatz Direktverkauf',
      fields: [
        {key: 'marketplace', label: 'Marktplatz'},
        {key: 'is_active', label: 'Status'}
      ],
      erp: [],
      ftp: [],
      stores: [{
        marketplace: 'Amazon',
        is_active: false
      }]
    }
  },
  methods: {
    getErp(){
      API.get(`/directsales/${this.$route.params.id}/erp`)
        .then(response => {
          this.erp = response.data
        })},
    getFtp() {
      API.get(`/directsales/${this.$route.params.id}/ftp`)
        .then(response => {
          this.ftp = response.data
        })
    },
    getMp () {
      API.get(`/directsales/${this.$route.params.id}/amazon/mpstatus`)
        .then(response => {
          this.stores[0].is_active = response.data.is_active
        })
    }
  },
  mounted () {
    this.getErp()
    this.getFtp()
    this.getMp()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/tools/MarketplaceDirectSaleBox.vue